import React from 'react'
import { BoxCard, LinkCard, ConclusionPage, Header } from '../../styles.style'
import { routes } from '../../../../constants/routes.constants'

const Conclusion = ({ providerSignupData }) => {
	const { MUVICARD_CADASTRO } = routes
	return (
		<ConclusionPage>
			<Header>
				<div className="title">
					<span>Agora você já faz parte do Muviflex</span>
				</div>
				<p>Complete o cadastro para ter seu Muvicard</p>
			</Header>
			<BoxCard>
				<ul>
					<li>
						<strong>{providerSignupData.name}</strong>
					</li>
				</ul>
			</BoxCard>
			<LinkCard
				href={MUVICARD_CADASTRO}
				title="Fazer meu cartão Muvicard"
				className="orange">
				Vamos lá!
			</LinkCard>
			<LinkCard
				title="Finalizar cadastro em outro momento"
				href="/"
				className="blue">
				Finalizar cadastro em outro momento
			</LinkCard>
		</ConclusionPage>
	)
}

export default Conclusion
